import { call, put, select } from 'redux-saga/effects';
import { iActionGetAll } from '~/domain/interfaces/redux/supportDoc/getAll';
import { makeRemoteGetAllSupportDocs } from '~/main/factories/usecases/supportDoc/GetAllSupportDocsFactory';
import { GetAllSupportDocs } from '~/domain/usecases/supportDoc/redux';
import {
  getAllFailed,
  getAllSuccess,
} from '~/data/store/reducer/supportDoc/actions/getAll';

export function* onGetAll(action: iActionGetAll) {
  const supportDoc = makeRemoteGetAllSupportDocs();
  try {
    const response: GetAllSupportDocs.Model = yield call(
      supportDoc.getAll,
      action.payload,
    );

    yield put(getAllSuccess(response));
  } catch (e) {
    console.error(e);
    yield put(getAllFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onGetAllFailed() {}
